import { TutorialIdType } from 'types/Tutorial';
import { TriggerTutorialOptionsType } from './tutorial';
import {
	LOAD_TUTORIALS_FAILURE,
	LOAD_TUTORIALS_SUCCESS,
	TRIGGER_TUTORIAL,
	TRIGGER_TUTORIAL_DELAYED,
	UN_TRIGGER_TUTORIAL,
	UPDATE_TUTORIAL_FLAG,
	UPDATE_TUTORIAL_FLAG_FAILURE,
	UPDATE_TUTORIAL_FLAG_INSTANTLY,
	UPDATE_TUTORIAL_FLAG_SUCCESS,
} from './tutorial.actionTypes';

export const actionCreators = {
	doTriggerTutorial: (flag: TutorialIdType, delay?: number, options?: TriggerTutorialOptionsType) => ({
		type: TRIGGER_TUTORIAL,
		flag,
		delay,
		options,
	}),
	doTriggerTutorialDelayed: (flag: TutorialIdType, options?: TriggerTutorialOptionsType) => ({
		type: TRIGGER_TUTORIAL_DELAYED,
		flag,
		options,
	}),
	doUnTriggerTutorial: () => ({
		type: UN_TRIGGER_TUTORIAL,
	}),
	doLoadTutorialsSuccess: (tutorials: any = {}) => ({
		type: LOAD_TUTORIALS_SUCCESS,
		tutorials,
	}),
	doLoadTutorialsFailure: (error: any = {}) => ({
		type: LOAD_TUTORIALS_FAILURE,
		error,
	}),
	doUpdateTutorialFlag: (flag: TutorialIdType, value: boolean = false) => ({
		type: UPDATE_TUTORIAL_FLAG,
		flag,
		value,
	}),
	doUpdateTutorialFlagInstantly: (flag: TutorialIdType, value: boolean = false) => ({
		type: UPDATE_TUTORIAL_FLAG_INSTANTLY,
		flag,
		value,
	}),
	doUpdateTutorialFlagSuccess: (flag: TutorialIdType, value: boolean = false) => ({
		type: UPDATE_TUTORIAL_FLAG_SUCCESS,
		flag,
		value,
	}),
	doUpdateTutorialFlagFailure: (error: any = {}) => ({
		type: UPDATE_TUTORIAL_FLAG_FAILURE,
		error,
	}),
};

export type TutorialActionType =
	| ReturnType<typeof actionCreators.doTriggerTutorial>
	| ReturnType<typeof actionCreators.doTriggerTutorialDelayed>
	| ReturnType<typeof actionCreators.doUnTriggerTutorial>
	| ReturnType<typeof actionCreators.doLoadTutorialsSuccess>
	| ReturnType<typeof actionCreators.doLoadTutorialsFailure>
	| ReturnType<typeof actionCreators.doUpdateTutorialFlag>
	| ReturnType<typeof actionCreators.doUpdateTutorialFlagInstantly>
	| ReturnType<typeof actionCreators.doUpdateTutorialFlagSuccess>
	| ReturnType<typeof actionCreators.doUpdateTutorialFlagFailure>;
